import { ACTION_COMMAND_SCHEMA } from '../Hasp/properties/v2/actionCommands.js';

export function getAvailableCommands() {
    return ACTION_COMMAND_SCHEMA;
}

export function getCommandDefinition(commandId) {
    return ACTION_COMMAND_SCHEMA.find(command => command.id === commandId);
}

